export const MAX_FILTERS_RANGE_VALUES = {
  RENT_PRICE: 10000,
  SELL_PRICE: 5000000,
  ROOMS: 10,
  AREA: 250,
  LAND_AREA: 2000,
};
